<template>
  <Modal
    ref="modal"
    :title="title"
    size="xs"
    @hide="$emit('hide')"
  >
    <p class="q-mb-none">{{ message }}</p>

    <template v-slot:actions>
      <q-btn
        v-if="cancel"
        flat
        label="Cancel"
        @click="onCancel"
      />
      <q-btn
        flat
        label="OK"
        color="primary"
        @click="onOk"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';

export default {
  emits: ['cancel', 'hide', 'ok'],
  components: { Modal },
  props: {
    title: { type: String, default: 'Confirm' },
    message: { type: String, default: '' },
    cancel: { type: Boolean, default: false },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onOk() {
      this.$emit('ok');
      this.hide();
    },
    onCancel() {
      this.$emit('cancel');
      this.hide();
    },
  },
};
</script>
